<template>
      <v-card v-bind:style="{'background-color': (Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color : ''), 'margin-top': '80px'}">
        <v-footer
          absolute
          class="font-weight-medium white--text"
          v-bind:style="{'background-color': (Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color : '')}"
        >
          <v-col
            class="text-center"
            cols="12"
          >
          <strong>{{ 'Powered by Evaluation Experts' | translate }}</strong>
          </v-col>
        </v-footer>
      </v-card>    
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name:"Footer",
  computed: {
    ...mapGetters([
      "currentUser",
    ]),
    }

}
</script>